import { memo } from 'react';
import { useStore } from '../../store/useStore';
import { Arrow } from './Arrow';
import { MagicProjectile } from './MagicProjectile';
import { HitEffect } from './HitEffect';

const ProjectileItem = memo(({ index }: { index: number }) => {
    const proj = useStore((state) => state.projectilePool[index]);

    if (!proj) return null;

    if (proj.type === 'arrow') {
        return <Arrow
            id={proj.id}
            active={proj.active}
            position={proj.position}
            targetPoint={proj.targetPoint}
            speed={proj.speed}
            startTimeStamp={proj.startTime}
        />;
    } else if (proj.type === 'magic') {
        return <MagicProjectile
            id={proj.id}
            active={proj.active}
            position={proj.position}
            targetPoint={proj.targetPoint}
            speed={proj.speed}
            startTimeStamp={proj.startTime}
        />;
    }
    return null;
});

const HitItem = memo(({ index }: { index: number }) => {
    const hit = useStore((state) => state.hitPool[index]);
    const deactivateHit = useStore((state) => state.deactivateHit);

    if (!hit) return null;

    return (
        <HitEffect
            id={hit.id}
            active={hit.active}
            position={hit.position}
            color={hit.color}
            onComplete={() => deactivateHit(hit.id)}
        />
    );
});

export const ProjectileManager = memo(() => {
    // We assume pool sizes are fixed as initialized in store
    const projCount = 80;
    const hitCount = 60;

    return (
        <group>
            {Array.from({ length: projCount }).map((_, i) => (
                <ProjectileItem key={`proj-${i}`} index={i} />
            ))}
            {Array.from({ length: hitCount }).map((_, i) => (
                <HitItem key={`hit-${i}`} index={i} />
            ))}
        </group>
    );
});
